<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>person</md-icon>
          </template>

          <template slot="content">
            <p class="category">Users</p>
            <h3 class="title">{{ dashboardStats.activeUsersCount }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a
                :class="{
                  'cursor-class': isViewer,
                  'show-add-user-deleted-app': isViewer,
                }"
                @click.prevent="showAddUser = !isViewer"
              >
                <md-icon>add</md-icon>
                Add new user
              </a>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>apps</md-icon>
          </template>

          <template slot="content">
            <p class="category">Applications</p>
            <h3 class="title">
              {{ dashboardStats.activeApplicationsCount }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a
                :class="{
                  'cursor-class': isViewer,
                  'show-add-user-deleted-app': isViewer,
                }"
                @click.prevent="showAddApplication = !isViewer"
              >
                <md-icon>add</md-icon>
                Add new application
              </a>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card">
        <stats-card data-background-color="green">
          <template slot="header">
            <i class="flaticon-029-check flaticon-sec"></i>
          </template>

          <template slot="content">
            <p class="category" style="font-size:0.95em;">Successful Auth.</p>
            <h3 class="title">
              {{ dashboardStats.successfulLoginRatio }}
              <small>%</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports'
                }"
              >
                <md-icon>keyboard_arrow_right</md-icon>
                Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card flt-stats-card stat-card">
        <stats-card data-background-color="red">
          <template slot="header">
            <i class="flaticon-030-attention flaticon-sec"></i>
          </template>

          <template slot="content">
            <p class="category">Frauds</p>
            <h3 class="title">
              {{ dashboardStats.frauds }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports'
                }"
              >
                <md-icon>keyboard_arrow_right</md-icon>
                Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <!-- Charts -->
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="purple" class="md-layout">
            <div class="md-layout-item md-size-70 ">
              <h4 class="title">
                Authentication Chart ({{ authChart.countAll }}
                Authentications)
              </h4>
              <p class="category">
                In last <b>{{ authChart.period }}</b> every
                <b>{{ authChart.epoch }}</b>
              </p>
            </div>
            <div class="md-layout-item md-size-30 text-right">
              <md-switch v-model="isLongTerm">
                Short/Long Term
              </md-switch>
            </div>
          </md-card-header>
          <md-card-content>
            <v-chart
              style="width: 100%; height: 400px; display: flex; justify-content: center"
              :options="authChart.options"
            />
          </md-card-content>
        </md-card>
      </div>
      <!--            Create user and Create application forms-->
      <create-new-user v-if="!isViewer" :show="showAddUser" @close="showAddUser = false"></create-new-user>
      <create-new-application
        v-if="!isViewer"
        :show="showAddApplication"
        @close="showAddApplication = false"
      ></create-new-application>
    </div>
  </div>
</template>

<script>
import { StatsCard, CreateNewUser, CreateNewApplication } from "@/components";
import { ref, onMounted, watch, computed } from "@vue/composition-api";
import apiManager from "../api-manager";
import numberSIPrefixFormatter from "../utils/numberSIPrefixFormatter";
import snakeCaseObjectKeysToCamelCase from "../utils/snakeCaseObjectKeysToCamelCase";

export default {
  components: {
    CreateNewApplication,
    CreateNewUser,
    StatsCard
  },
  setup() {
    const dashboardStats = ref({
      activeUsersCount: 0,
      applicationsCount: 0,
      activeApplicationsCount: 0,
      successfulLoginRatio: 0,
      frauds: 0,
      txAll: 0
    });
    const getDashboardStats = async () => {
      const response = await apiManager.dashboardStats();
      dashboardStats.value = snakeCaseObjectKeysToCamelCase(response.parsedData);
    };
    onMounted(() => {
      getDashboardStats();
    });

    const authChart = ref({
      countAll: 0,
      period: "48 hours",
      epoch: "30 minutes",
      options: {}
    });
    const getAuthChartData = async () => {
      const response = await apiManager.dashboardCharts({
        params: {
          period: chartConfig.value.period,
          epoch: chartConfig.value.epoch
        }
      });
      authChart.value.countAll = numberSIPrefixFormatter(response.parsedData.count_all);
      authChart.value.period = response.parsedData.period;
      authChart.value.epoch = response.parsedData.epoch;
      authChart.value.options = {
        legend: {
          show: true
        },
        tooltip: {},
        dataset: {
          source: response.parsedData.data
        },
        xAxis: { type: "category", name: "Time" },
        yAxis: { name: "#TXs" },
        series: [{ type: "bar" }, { type: "bar" }]
      };
    };
    onMounted(() => {
      getAuthChartData();
    });

    const isLongTerm = ref(false);
    const chartConfig = ref({
      period: 48,
      epoch: 30
    });
    watch(
      () => isLongTerm.value,
      (value, oldValue) => {
        chartConfig.value = value ? { period: 2160, epoch: 4320 } : { period: 48, epoch: 30 };
        getAuthChartData();
      }
    );

    const showAddUser = ref(false);
    const showAddApplication = ref(false);

    const isViewer = computed(() => {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins");
    });

    return {
      dashboardStats,
      authChart,
      isLongTerm,
      chartConfig,
      showAddApplication,
      showAddUser,
      isViewer,
    };
  }
};
</script>
<style lang="scss" scoped>
.stat-card {
  @media (max-width: 1400px) {
    min-width: 50% !important;
    max-width: 50% !important;
    flex: 0 1 50% !important;
  }
  @media (max-width: 540px) {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 1 100% !important;
  }
}

a {
  cursor: pointer;
}

.md-theme-default a:not(.md-button).show-add-user-deleted-app,
.md-theme-default a:not(.md-button).show-add-user-deleted-app:hover {
  color: var(--md-theme-default-primary-on-background, gray) !important;
}

.cursor-class {
  cursor: not-allowed;
}
</style>
